import {injectable} from 'inversify';

import type {CouponModel} from './Coupon.model';

import {BaseController} from '../../../core/domain/Base/Base.controller';

@injectable()
export class CouponController extends BaseController<CouponModel> {
  constructor() {
    super();
  }
}
